var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"modal-back"},[_c('transition',[_c('div',{staticClass:"modal-popup"},[_vm._t("default")],2)])],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }